import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { festivalService } from '../../services/festivalService';
import { Bar, Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js';
import './Reports.css';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

const Reports = () => {
  const { t } = useTranslation();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    setLoading(true);
    try {
      const response = await festivalService.getFestivalStats();
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">{t('loading')}</div>;
  }

  if (!stats) {
    return <div className="error">Failed to load statistics</div>;
  }

  const languageChartData = {
    labels: stats.festivalsByLanguage.map(item => item._id),
    datasets: [
      {
        label: 'Festivals by Language',
        data: stats.festivalsByLanguage.map(item => item.count),
        backgroundColor: [
          '#17479e',
          '#ee3824',
          '#4caf50',
          '#ff9800',
          '#9c27b0',
          '#00bcd4',
          '#ffc107',
          '#e91e63'
        ]
      }
    ]
  };

  const stateChartData = {
    labels: stats.festivalsByState.map(item => item._id),
    datasets: [
      {
        label: 'Festivals by State',
        data: stats.festivalsByState.map(item => item.count),
        backgroundColor: '#17479e'
      }
    ]
  };

  return (
    <div className="reports-container">
      <h1>{t('reports')}</h1>

      <div className="stats-overview">
        <div className="stat-card">
          <h3>Total Festivals</h3>
          <p className="stat-number">{stats.totalFestivals}</p>
        </div>
        <div className="stat-card">
          <h3>Total Views</h3>
          <p className="stat-number">{stats.totalViews}</p>
        </div>
        <div className="stat-card">
          <h3>Languages</h3>
          <p className="stat-number">{stats.festivalsByLanguage.length}</p>
        </div>
        <div className="stat-card">
          <h3>States</h3>
          <p className="stat-number">{stats.festivalsByState.length}</p>
        </div>
      </div>

      <div className="charts-grid">
        <div className="chart-container">
          <h3>Festivals by Language</h3>
          <Pie data={languageChartData} />
        </div>
        <div className="chart-container">
          <h3>Festivals by State (Top 10)</h3>
          <Bar data={stateChartData} options={{ indexAxis: 'y' }} />
        </div>
      </div>

      <div className="most-viewed">
        <h3>Most Viewed Festivals</h3>
        <table>
          <thead>
            <tr>
              <th>Festival</th>
              <th>Date</th>
              <th>Views</th>
            </tr>
          </thead>
          <tbody>
            {stats.mostViewedFestivals.map((festival) => (
              <tr key={festival._id}>
                <td>{festival.name?.en || festival.name || 'Unknown'}</td>
                <td>{new Date(festival.date).toLocaleDateString()}</td>
                <td>{festival.viewCount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Reports;
